// import React, { useEffect, useRef, useState } from "react";
// import { Box, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import HoverButton from "../../components/HoverButton";
// import EastIconArrow from "../../../src/assets/east.svg";
// import TS from "../../../src/assets/TropicalSuiteImg/TS16.jpg";
// import TC from "../../../src/assets/TropicalCircle.png";
// import AS from "../../../src/assets/AmberSuiteImg/AS14.jpg";
// import AC from "../../../src/assets/AmberCircle.png";
// import ES from "../../../src/assets/EarthenSuiteImg/ES14.jpg";
// import EC from "../../../src/assets/EarthenCircle.png";

// gsap.registerPlugin(ScrollTrigger);

// const suiteData = {
//   tropical: {
//     backgroundColor: "#DCF6EF",
//     title: "THE TROPICAL SUITE",
//     subtitle:
//       "A vibrant retreat with lush greenery and breezy interiors, perfect for a refreshing stay",
//     imageSrc: TS,
//     circleSrc: TC,
//     buttonColor: "#9DC5B9",
//     navigateTo: "/the-tropical-suite",
//     description: [
//       "Relax in a nature-inspired space, where comfort meets tranquility for a truly rejuvenating escape.",
//       "2000 sq. ft. • max. 4 guests",
//     ],
//   },
//   amber: {
//     backgroundColor: "#FDEEB7",
//     title: "THE AMBER SUITE",
//     subtitle:
//       "A warm, elegant space designed with golden hues and wooden accents.",
//     imageSrc: AS,
//     circleSrc: AC,
//     buttonColor: "#F3D991",
//     navigateTo: "/the-amber-suite",
//     description: [
//       "Step into a cozy yet sophisticated retreat, where earthy tones and soft lighting create an inviting ambiance for a peaceful and luxurious stay.",
//       "2000 sq. ft. • max. 4 guests",
//     ],
//   },
//   earthen: {
//     backgroundColor: "#FFDCCD",
//     title: "THE EARTHEN SUITE",
//     subtitle:
//       "Inspired by nature, featuring rustic textures and calming neutral tones.",
//     imageSrc: ES,
//     circleSrc: EC,
//     buttonColor: "#DDB0A5",
//     navigateTo: "/the-earthen-suite",
//     description: [
//       "This serene retreat blends organic elements with modern comfort, offering a grounding and rejuvenating escape amidst a peaceful setting.",
//       "2000 sq. ft. • max. 4 guests",
//     ],
//   },
// };

// const styles = {
//   sectionContainer: (bg) => ({
//     backgroundColor: bg,
//     width: "100vw",
//     height: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//     overflow: "hidden",
//     padding: "5vh 0",
//   }),
//   textSection: {
//     position: "absolute",
//     top: "15%",
//     left: "5%",
//     color: "#2A2A2A",
//     zIndex: 2,
//     width: "300px",
//   },
//   title: {
//     fontFamily: "'ZapfHumnst BT'",
//     fontWeight: 400,
//     textTransform: "uppercase",
//     fontSize: { xs: "32px", md: "50px", lg: "74px" },
//     lineHeight: { xs: "39.61px", md: "40px", lg: "91.6px" },
//     color: "#2A2A2A",
//   },
//   subtitle: {
//     maxWidth: "292px",
//     fontFamily: "'Sora', sans-serif",
//     fontSize: { xs: "12px", lg: "16px" },
//     fontWeight: 300,
//     color: "#000000",
//   },
//   imageWrapper: {
//     position: "relative",
//     width: "90vw",
//     maxWidth: "438px",
//     height: "auto",
//     aspectRatio: "3 / 4",
//     minHeight: "300px",
//     maxHeight: "585px",
//   },
//   suiteImage: {
//     position: "absolute",
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     borderRadius: "300px 300px 0px 0px",
//     zIndex: 1,
//   },
//   circleImage: {
//     width: "175px",
//     height: "175px",
//     position: "absolute",
//     objectFit: "cover",
//     bottom: "-50px",
//     left: "0%",
//     transform: "translateX(-50%)",
//     zIndex: 0,
//   },
//   buttonSection: {
//     position: "absolute",
//     bottom: "15%",
//     right: "8%",
//     zIndex: 2,
//     width: "300px",
//   },
//   descriptionText: {
//     maxWidth: "292px",
//     fontFamily: "'Sora', sans-serif",
//     fontSize: { xs: "12px", lg: "16px" },
//     fontWeight: 300,
//     color: "#000000",
//     marginTop: "10px",
//     textAlign:"justify"
//   },
//   eastIcon: {
//     width: "25px",
//     height: "25px",
//     transform: "rotate(-50deg)",
//   },
// };

// const HomeSuites = () => {
//   const navigate = useNavigate();
//   const textRefs = useRef([]);
//   const imageRefs = useRef([]);
//   const buttonRefs = useRef([]);

//   const [imagesLoaded, setImagesLoaded] = useState(0);
//   const totalImages = Object.keys(suiteData).length * 2;

//   useEffect(() => {
//     if (imagesLoaded === totalImages) {
//       textRefs.current.forEach((textRef) => {
//         gsap.fromTo(
//           textRef,
//           { x: "-50%", opacity: 0 },
//           {
//             x: "0%",
//             opacity: 1,
//             duration: 1.2,
//             ease: "power2.out",
//             scrollTrigger: {
//               trigger: textRef,
//               start: "top 80%",
//               once: true,
//             },
//           }
//         );
//       });

//       imageRefs.current.forEach((imageRef) => {
//         gsap.fromTo(
//           imageRef,
//           { opacity: 0, scale: 0.8 },
//           {
//             opacity: 1,
//             scale: 1,
//             duration: 1,
//             ease: "power2.out",
//             scrollTrigger: {
//               trigger: imageRef,
//               start: "top 60%",
//               once: true,
//             },
//           }
//         );
//       });

//       buttonRefs.current.forEach((buttonRef) => {
//         gsap.fromTo(
//           buttonRef,
//           { x: "50%", opacity: 0 },
//           {
//             x: "0%",
//             opacity: 1,
//             duration: 1.2,
//             ease: "power2.out",
//             scrollTrigger: {
//               trigger: buttonRef,
//               start: "top 80%",
//               once: true,
//             },
//           }
//         );
//       });
//     }
//   }, [imagesLoaded]);

//   return (
//     <Box>
//       {Object.entries(suiteData).map(([key, suite], index) => (
//         <Box key={key} sx={styles.sectionContainer(suite.backgroundColor)}>
//           {/* Text */}
//           <div ref={(el) => (textRefs.current[index] = el)} style={styles.textSection}>
//             <Typography sx={styles.title}>{suite.title}</Typography>
//             <Typography sx={styles.subtitle}>{suite.subtitle}</Typography>
//           </div>

//           {/* Images */}
//           <div ref={(el) => (imageRefs.current[index] = el)} style={styles.imageWrapper}>
//             <img
//               src={suite.imageSrc}
//               alt="suite"
//               onLoad={() => setImagesLoaded((prev) => prev + 1)}
//               style={styles.suiteImage}
//             />
//             <img
//               src={suite.circleSrc}
//               alt="decorative circle"
//               onLoad={() => setImagesLoaded((prev) => prev + 1)}
//               style={styles.circleImage}
//             />
//           </div>

//           {/* Button & Description */}
//           <div ref={(el) => (buttonRefs.current[index] = el)} style={styles.buttonSection}>
//             <HoverButton
//               onClick={() => navigate(suite.navigateTo)}
//               width={"132px"}
//               height={"50px"}
//               endIcon={<img src={EastIconArrow} alt="east" style={styles.eastIcon} />}
//               btnText={"Step in"}
//               fillBgColor={suite.buttonColor}
//             />
//             {suite.description.map((line, idx) => (
//               <Typography key={idx} sx={styles.descriptionText}>
//                 {line}
//               </Typography>
//             ))}
//           </div>
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default HomeSuites;


import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HoverButton from "../../components/HoverButton";
import EastIconArrow from "../../../src/assets/east.svg";
import TS from "../../../src/assets/TropicalSuiteImg/TS16.jpg";
import TC from "../../../src/assets/TropicalCircle.png";
import AS from "../../../src/assets/AmberSuiteImg/AS14.jpg";
import AC from "../../../src/assets/AmberCircle.png";
import ES from "../../../src/assets/EarthenSuiteImg/ES14.jpg";
import EC from "../../../src/assets/EarthenCircle.png";
const isMdUp = window.innerWidth >= 1024;
gsap.registerPlugin(ScrollTrigger);

const suiteData = {
  tropical: {
    backgroundColor: "#DCF6EF",
    title: "THE TROPICAL SUITE",
    subtitle:
      "A vibrant retreat with lush greenery and breezy interiors, perfect for a refreshing stay",
    imageSrc: TS,
    circleSrc: TC,
    buttonColor: "#9DC5B9",
    navigateTo: "/the-tropical-suite",
    description: [
      "Relax in a nature-inspired space, where comfort meets tranquility for a truly rejuvenating escape.",
      "2000 sq. ft. • max. 4 guests",
    ],
  },
  amber: {
    backgroundColor: "#FDEEB7",
    title: "THE AMBER SUITE",
    subtitle:
      "A warm, elegant space designed with golden hues and wooden accents.",
    imageSrc: AS,
    circleSrc: AC,
    buttonColor: "#F3D991",
    navigateTo: "/the-amber-suite",
    description: [
      "Step into a cozy yet sophisticated retreat, where earthy tones and soft lighting create an inviting ambiance for a peaceful and luxurious stay.",
      "2000 sq. ft. • max. 4 guests",
    ],
  },
  earthen: {
    backgroundColor: "#FFDCCD",
    title: "THE EARTHEN SUITE",
    subtitle:
      "Inspired by nature, featuring rustic textures and calming neutral tones.",
    imageSrc: ES,
    circleSrc: EC,
    buttonColor: "#DDB0A5",
    navigateTo: "/the-earthen-suite",
    description: [
      "This serene retreat blends organic elements with modern comfort, offering a grounding and rejuvenating escape amidst a peaceful setting.",
      "2000 sq. ft. • max. 4 guests",
    ],
  },
};

const styles = {
  sectionContainer: (bg) => ({
    backgroundColor: bg,
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    padding: "5vh 0",
  }),
  textSection: {
    position: "absolute",
    top: "15%",
    left: "5%",
    color: "#2A2A2A",
    zIndex: 2,
    width: "100%",
    maxWidth: "275px",
    lineHeight: "20px"
  },
  title: {
    fontFamily: "'ZapfHumnst BT'",
    fontWeight: 400,
    textTransform: "uppercase",
    fontSize: { xs: "32px", md: "50px", lg: "74px" },
    lineHeight: { xs: "39.61px", md: "40px", lg: "91.6px" },
    color: "#2A2A2A",
  },
  subtitle: {
    maxWidth: "245px",
    fontFamily: "'Sora', sans-serif",
    fontSize: { xs: "16px", lg: "16px" },
    fontWeight: 300,
    color: "#000000",
  },
  imageWrapper: {
    position: "relative",
    width: "90vw",
    maxWidth: "438px",
    height: "auto",
    aspectRatio: "3 / 4",
    minHeight: "300px",
    maxHeight: "585px",
  },
  suiteImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "350px 350px 0px 0px",
    zIndex: 1,
  },
  circleImage: {
    width: "175px",
    height: "175px",
    position: "absolute",
    objectFit: "cover",
    bottom: "-50px",
    left: "0%",
    transform: "translateX(-50%)",
    zIndex: 0,
  },
  buttonSection: {
    position: "absolute",
    bottom: "15%",
    right: "8%",
    zIndex: 2,
    width: "300px",
  },
  descriptionText: {
    maxWidth: "292px",
    fontFamily: "'Sora', sans-serif",
    fontSize: { xs: "12px", lg: "16px" },
    fontWeight: 300,
    color: "#000000",
    marginTop: "10px",
    textAlign: "justify"
  },
  eastIcon: {
    width: "25px",
    height: "25px",
    transform: "rotate(-50deg)",
  },
};

const HomeSuites = () => {
  const navigate = useNavigate();
  const textRefs = useRef([]);
  const imageRefs = useRef([]);
  const buttonRefs = useRef([]);

  const [imagesLoaded, setImagesLoaded] = useState(0);
  const totalImages = Object.keys(suiteData).length * 2;

  useEffect(() => {
    if (imagesLoaded === totalImages) {
      textRefs.current.forEach((textRef) => {
        gsap.fromTo(
          textRef,
          { x: "-50%", opacity: 0 },
          {
            x: "0%",
            opacity: 1,
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: textRef,
              start: "top 80%",
              once: true,
            },
          }
        );
      });

      imageRefs.current.forEach((imageRef) => {
        gsap.fromTo(
          imageRef,
          { opacity: 0, scale: 0.8 },
          {
            opacity: 1,
            scale: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: imageRef,
              start: "top 60%",
              once: true,
            },
          }
        );
      });

      buttonRefs.current.forEach((buttonRef) => {
        gsap.fromTo(
          buttonRef,
          { x: " 10%", opacity: 0 },
          {
            x: "-0%",
            opacity: 1,
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: buttonRef,
              start: "top 80%",
              once: true,
            },
          }
        );
      });
    }
  }, [imagesLoaded, totalImages]);

  return (
    <Box>
      {Object.entries(suiteData).map(([key, suite], index) => (
        <Box key={key} sx={styles.sectionContainer(suite.backgroundColor)}>
          <div ref={(el) => (textRefs.current[index] = el)} style={styles.textSection}>
            <Typography sx={styles.title}>{suite.title}</Typography>
            <Typography sx={styles.subtitle}>{suite.subtitle}</Typography>
          </div>
          <div ref={(el) => (imageRefs.current[index] = el)} style={styles.imageWrapper}>
            <img
              src={suite.imageSrc}
              alt="suite"
              onLoad={() => setImagesLoaded((prev) => prev + 1)}
              style={styles.suiteImage}
            />
            <img
              src={suite.circleSrc}
              alt="decorative circle"
              onLoad={() => setImagesLoaded((prev) => prev + 1)}
              style={styles.circleImage}
            />
          </div>

          < div ref={el => buttonRefs.current[index] = el} style={{
            position: "absolute",
            bottom: "15%",
            right : "10%",
            zIndex: 2,
            width: "100%",
            maxWidth: "275px",
            textAlign: "justify",
            // maxWidth: { xs: "180px", md: "300px", lg: "372px" },
          }}>
            <HoverButton
              onClick={() => navigate(suite.navigateTo)}
              width={"132px"}
              height={"50px"}
              endIcon={<img src={EastIconArrow} alt="east" style={{
                width: "25px",
                height: "25px",
                transform: "rotate(-50deg)",
              }} />}
              btnText={"Step in"}
              fillBgColor={suite.buttonColor}
            />
            {suite.description.map((line, idx) => (
              <Typography key={idx} sx={{
                width: "100%",
                maxWidth: { xs: "200px", md: "300px", lg: "472px" },
                fontFamily: "'Sora', sans-serif",
                fontSize: { xs: "16px", lg: "16px" },
                fontWeight: 300,
                color: "#000000",
                marginTop: "10px",
              }}>
                {line}
              </Typography>
            ))}
          </div>
        </Box>
      ))}
    </Box>
  );
};

export default HomeSuites;
